import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

export type CacheStatus = 'HIT' | 'STALE' | 'NETWORK' | 'OFFLINE';

export interface CacheStatusEvent {
  url: string;
  status: CacheStatus;
}

@Injectable({providedIn: 'root'})
export class CacheStatusService {
  private statusSubject = new BehaviorSubject<CacheStatusEvent | null>(null);
  private statusMap = new Map<string, CacheStatus>();

  notify(url: string, status: CacheStatus): void {
    this.statusMap.set(url, status);
    this.statusSubject.next({url, status});
  }

  get status$(): Observable<CacheStatusEvent | null> {
    return this.statusSubject.asObservable();
  }

  getStatus(url: string): CacheStatus | null {
    return this.statusMap.get(url) || null;
  }
}
